<template>
  <textarea
    :id="accessibilityId"
    v-model="modelVal"
    class="own-textarea text-paragraph-regular"
    :class="[error && 'own-textarea--error', isEmpty && 'own-textarea--empty']"
    :name="accessibilityId"
    :rows="rows"
    :disabled="disabled"
    :placeholder="placeholder"
  ></textarea>
</template>

<script lang="ts" setup>
import { isDefined } from '@vueuse/core'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    accessibilityId?: string
    disabled?: boolean
    emptyAsNull?: boolean
    error?: boolean
    placeholder?: string
    rows?: string
  }>(),
  {
    accessibilityId: undefined,
    disabled: false,
    emptyAsNull: false,
    error: false,
    placeholder: undefined,
    rows: '5',
  }
)

const modelVal = defineModel<string>({
  set(newVal) {
    if (props.emptyAsNull && newVal === '') {
      return null
    }
    return newVal
  },
})
defineEmits<{ 'update:modelValue': [value: string | undefined | null] }>()

const isEmpty = computed(() => {
  return !isDefined(modelVal.value) || modelVal.value === ''
})
</script>

<style lang="scss">
@use '@/styles/globals';

.own-textarea {
  padding: 12px;
  border-radius: var(--radius-regular);

  background-color: var(--background-primary);
  color: var(--text-color-primary);

  box-shadow: var(--shadow-card-default);

  transition:
    globals.transitionOne(border), globals.transitionOne(color),
    globals.transitionOne(background-color), globals.transitionOne(box-shadow);

  &::placeholder {
    color: var(--text-color-tertiary);
  }

  &:disabled {
    cursor: not-allowed;
    color: var(--text-color-tertiary);
    background-color: var(--background-secondary);
    border-color: var(--divider);
    opacity: 0.6;

    &::placeholder {
      color: var(--text-color-tertiary);
    }
  }

  &--error {
    border-color: var(--status-danger) !important;
  }

  &:hover,
  &:active,
  &:focus {
    background-color: var(--background-highlight);
    border-color: rgba(var(--raw-misc-brand), 0.05);
  }
}
</style>
